import { FC } from 'react'

import { StyledIcon, Svg } from './styles'
import { GeneratedIconProps, IconProps, iconSizes } from './types'

export const Icon = ({
  icon,
  viewBox,
  width,
  height,
  className,
  color,
}: IconProps) => (
  <Svg
    viewBox={viewBox}
    className={`icon ${className || ''}`}
    width={width}
    height={height}
    iconColor={color}
  >
    <use xlinkHref={`#${icon}`} />
  </Svg>
)

export const GeneratedIcon: FC<GeneratedIconProps> = ({
  size: propsSize,
  color: propsColor,
  children,
  ...rest
}) => {
  const size = propsSize ? iconSizes[propsSize] : iconSizes.small
  return (
    <StyledIcon className="icon" iconColor={propsColor} size={size} {...rest}>
      <Svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
        {children}
      </Svg>
    </StyledIcon>
  )
}
